export default __webpack_public_path__ + "static/media/uma.07dde6ed.jpg";